import { SetStateAction, Dispatch } from 'react'

import { useRouter } from 'next/navigation'

import { parseGraphQLErrorMessage } from '@components/utilities/parse-graphql-error-message'
import UserUtils from '@components/utilities/UserUtils'
import { routes } from '@constants/routes'
import { UserContextProps } from '@contexts/UserContext'
import { AppLocalStorage } from '@state/storage-wrapper'

interface HandleErrorProps {
  error: any // Leaving as error since I don't want to mess with places that already utilize this service
  setStateCallback?: Dispatch<SetStateAction<string>>
  onError?: (errorMessage: string) => void
  showLoginIfUnauthenticated?: boolean
  router: ReturnType<typeof useRouter>
}

export default class ErrorService {
  static context: UserContextProps

  static init({ context }: { context: UserContextProps }) {
    this.context = context
  }

  static async handleError({
    error,
    setStateCallback,
    onError,
    showLoginIfUnauthenticated = false,
    router,
  }: HandleErrorProps) {
    const errorMessage = parseGraphQLErrorMessage(error)
    console.log('Error: ', error)
    if (error?.graphQLErrors?.[0]?.extensions?.category === 'blocking_ip') {
      AppLocalStorage.setItem('swimply::block_user', 'true')
      AppLocalStorage.setItem(
        'swimply::block_user_error_msg',
        `${403}:${errorMessage}`
      )
      router.replace('/blocked')
    }

    if (errorMessage.includes('This action is unauthorized.')) {
      router.replace(routes.Home())
    } else if (errorMessage === 'Unauthenticated.') {
      if (showLoginIfUnauthenticated) {
        UserUtils.setWantsAuthentication()
      }

      try {
        setStateCallback?.(errorMessage)
        onError?.(errorMessage)

        await this.context.logout()
      } catch {
        //
      }
    } else {
      setStateCallback?.(errorMessage)
      onError?.(errorMessage)
    }
  }
}
